<script>
import Base from './Base';

export default {
  name: 'nx-social-network-send-to-twitter',
  extends: Base,
  data() {
    return {
      name: 'Twitter',
      type: 'twitterAccount',
    };
  },
};
</script>
